import { I18n } from '@aws-amplify/core';

import resources from 'data/i18n/resources';

// Internationalisation
I18n.putVocabularies(resources);
